import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import RUFlag from "@/assets/pics/countries/ru.png";
import KZFlag from "@/assets/pics/countries/kz.png";
import WorldFlag from "@/assets/pics/countries/world.png";

interface ICountries {
    keys: (string | number)[],
    text: string,
    flag: string,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseTranslateCountry',
  props: {
    textKey: null,
    src: null,
    alt: null
  },
  setup(__props: any) {

const props = __props as {
    textKey: string;
    src?: string;
    alt?: string;
}



const countries = ref<ICountries[]>([
    {
        keys: ['РФ', 'Россия', 'Российская Федерация', 'Ru', 1],
        text: 'Россия',
        flag: RUFlag,
    },
    {
        keys: ['РК', 'Казахстан', 'Республика Казахстан', 'Kz', 3],
        text: 'Казахстан',
        flag: KZFlag,
    },
    {
        keys: ['world', 'Мир', 4],
        text: 'Мир',
        flag: WorldFlag,
    },
]);

const getCountry = computed<ICountries | { text: string, flag: string }>(() => {
    const country = countries.value.find((el: ICountries) => {
        return el.keys.some((e: string) => {
            return String(e).toLowerCase() === String(props.textKey).toLowerCase();
        });
    });

    return country ? country : { text: '', flag: '' };
});

return { __sfc: true,props, countries, getCountry }
}

})